import { html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './ItemSeparator.css'

/**
 * Item Separator draws a horizontal divider between [Item](/components/item/)
 * rows inside an [Item Group](/components/item-group/).
 *
 * @status draft
 * @category list
 * @lightDom true
 *
 * @part separator - The dividing line.
 */
@customElement('nord-item-separator')
export default class ItemSeparator extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
    // The separator is a purely visual divider between items. Hide it from
    // assistive technology so it can sit inside a `list` (whose only allowed
    // children are list items) without breaking required-children rules.
    if (!this.hasAttribute('aria-hidden')) {
      this.setAttribute('aria-hidden', 'true')
    }
  }

  // Renders its own divider markup; there are no user children to preserve.
  protected createRenderRoot() {
    return this
  }

  render() {
    return html`<hr part="separator" />`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-item-separator': ItemSeparator
  }
}
